// extracted by mini-css-extract-plugin
export default {"root":"IconSupportChat_root__xn2xn"};